import Value from "aldoo-ra/Value"
import config from "aldoo-ra/Config"

//This is the key that stores the credentials in the local storage
export const persistKey = config.APP_NAME.toLowerCase().replace(" ", "-") + "-ck"


/**
 * Get the current user credentials that are synced
 * on the local storage
 * @returns
 */
export default function useAuth() {
    if (import.meta.env.SSR) return []
    //TODO: Security: allow option to specify encryption when a persistKey is provided
    const [auth, setAuth] = Value({
        key: "user-credentials",
        defaultValue: null,
        persistKey
    })

    // the provider token of a sign-in (oauth_token) proves the sign-in once, to the API;
    // it is never kept with the session
    const setAuthWithoutProof = (value) => {
        if (value && typeof value === "object" && "oauth_token" in value) {
            const { oauth_token, ...rest } = value
            return setAuth(rest)
        }
        return setAuth(value)
    }

    return [auth, setAuthWithoutProof]
}